import React from 'react';
import { CardMediaBox } from '../../CardComponents/card-media-box/component.js'; // To keep things DRY, splitting this off to a component

var LegacyMediaBox = function LegacyMediaBox(_ref) {
  var cardProps = _ref.cardProps,
      cardEffects = _ref.cardEffects;
  var mediaBackground = cardProps.mediaBackground,
      mediaDataAttributes = cardProps.mediaDataAttributes,
      mediaContent = cardProps.mediaContent,
      mediaUrl = cardProps.mediaUrl,
      mediaSize = cardProps.mediaSize,
      mediaPosition = cardProps.mediaPosition,
      type = cardProps.type;

  if (!mediaUrl && !mediaContent) {
    return null;
  }

  var hasLabel = cardEffects.hasLabel;
  return /*#__PURE__*/React.createElement(CardMediaBox, {
    chakra: 'off',
    mediaBackground: mediaBackground,
    mediaDataAttributes: mediaDataAttributes,
    mediaContent: mediaContent,
    mediaUrl: mediaUrl,
    mediaSize: type === 'narrow' ? 'full' : mediaSize,
    mediaPosition: mediaPosition,
    hasLabel: hasLabel,
    type: type
  });
};

LegacyMediaBox.displayName = "LegacyMediaBox";
export { LegacyMediaBox };